import * as React from 'react';
import { useModule } from '@starberry/components';
import { useFormState } from 'react-hook-form';

export const FormPasswordField = React.forwardRef((props, ref) => {
  const { onChange, onBlur, control, value, field, inputProps } = props;

  const PasswordField = useModule('PasswordField');

  const { errors } = useFormState({
    control,
    name: field.name,
    ...field,
    disabled: false,
  });

  return (
    <PasswordField
      {...field}
      inputProps={inputProps}
      error={errors[field.name]}
      value={value}
      ref={ref}
      onChange={() => onChange}
      onBlur={() => onBlur}
    />
  );
});

export default React.memo(FormPasswordField);
